import { render } from "./ListProductsByType.vue?vue&type=template&id=381c8b43"
import script from "./ListProductsByType.vue?vue&type=script&lang=js"
export * from "./ListProductsByType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__